import { type SvgIconProps } from '@common/components/svgs/props';
import '@common/styles/components/spinner.pcss';

function IconSpinner({
  size = 16,
  color,
  ...rest
}: Readonly<SvgIconProps>) {
  return (
    <svg // NOSONAR:S6819 - Valid ARIA role="status" for loading indicator
      {...rest}
      role="status"
      aria-label="Loading"
      className="spinner"
      width={size}
      height={size}
      viewBox="22 22 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-Spinner"
    >
      <circle
        cx="44"
        cy="44"
        r="20.2"
        stroke={`var(--${color ?? 'scheme-spinner-color'})`}
        strokeWidth="3.6"
      />
    </svg>
  );
}

IconSpinner.displayName = 'Spinner';

export default IconSpinner;
